export default "__VITE_ASSET__DUAx74nA__"